import { jsx } from "react/jsx-runtime";
import "react";
import { ErrorBoundary } from "react-error-boundary";
import { TravelBotChatSingleDialogGeneric } from "../../TravelBotChatSingleDialogGeneric.js";
import analytics from "../../analytics/analytics.js";
const defaultFallBackComponent = (displayedMessage)=>/*#__PURE__*/ jsx(TravelBotChatSingleDialogGeneric, {
        message: {
            role: 'assistant',
            content: displayedMessage
        }
    });
const ChatMessageErrorBoundary = ({ displayedMessage = '', children, FallbackComponent, compnentName })=>{
    const handleErrorLogging = function(error, info) {
        analytics.logError({
            compnentName,
            message: 'ChatMessageErrorBoundary',
            errorMessage: error?.message,
            ...info
        });
    };
    const Fallback = function() {
        return FallbackComponent ? FallbackComponent : defaultFallBackComponent(displayedMessage);
    };
    return /*#__PURE__*/ jsx(ErrorBoundary, {
        FallbackComponent: Fallback,
        onError: handleErrorLogging,
        children: children
    });
};
const ErrorBoundary_ChatMessageErrorBoundary = ChatMessageErrorBoundary;
export { ErrorBoundary_ChatMessageErrorBoundary as default };
